module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }]
  }, [_c('div', {
    staticClass: "m-b-20 ovf-hd"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.addShow),
      expression: "addShow"
    }],
    staticClass: "fl"
  }, [_c('router-link', {
    staticClass: "btn-link-large add-btn",
    attrs: {
      "to": "add"
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  }), _vm._v("  添加流程\n        ")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn-link-large add-btn m-l-10",
    attrs: {
      "to": "/flowtype/list"
    }
  }, [_vm._v("分类管理")])]), _vm._v(" "), _c('div', {
    staticClass: "fl w-300 m-l-30",
    on: {
      "keyup": function($event) {
        if (_vm._k($event.keyCode, "enter", 13)) { return; }
        _vm.search()
      }
    }
  }, [_c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.keywords),
      expression: "keywords"
    }],
    attrs: {
      "placeholder": "输入流程名称"
    },
    domProps: {
      "value": (_vm.keywords)
    },
    on: {
      "input": function($event) {
        _vm.keywords = $event
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "fl m-l-20"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索")])]), _vm._v(" "), _c('div', {
    staticClass: "fr"
  }, [_c('router-link', {
    attrs: {
      "to": "message"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    }
  }, [_vm._v("自动提醒配置")])])])]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData
    },
    on: {
      "selection-change": _vm.selectItem
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "50"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "名称",
      "prop": "name",
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "分类",
      "prop": "type_name",
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "最后更新时间",
      "prop": "update_time"
    },
    scopedSlots: {
      default: function(scope) {
        return [_c('div', [_vm._v("\n            " + _vm._s(_vm._f("parseTime")(scope.row.update_time)) + "\n          ")])]
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "状态",
      "prop": "status"
    },
    scopedSlots: {
      default: function(scope) {
        return [_c('div', {
          class: {
            'bad': scope.row.status === 0
          }
        }, [_vm._v("\n           " + _vm._s(_vm._f("parseStatus")(scope.row.status)) + "\n          ")])]
      }
    }
  }), _vm._v(" "), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "350"
    },
    scopedSlots: {
      default: function(scope) {
        return [_c('div', [_c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.editShow),
            expression: "editShow"
          }]
        }, [_c('router-link', {
          staticClass: "btn-link edit-btn m-r-5",
          attrs: {
            "to": {
              name: 'flowEdit',
              params: {
                id: scope.row.id
              }
            }
          }
        }, [_vm._v("\n            编辑\n              ")])]), _vm._v(" "), _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.designShow),
            expression: "designShow"
          }]
        }, [_c('router-link', {
          staticClass: "btn-link el-button el-button--default m-r-5",
          attrs: {
            "to": {
              name: 'flowDesign',
              params: {
                id: scope.row.id
              }
            }
          }
        }, [_vm._v("\n            配置流程\n              ")])]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small",
            "type": "primary",
            "loading": _vm.copyLoading
          },
          on: {
            "click": function($event) {
              _vm.copyFlow(scope.row.id)
            }
          }
        }, [_vm._v("复制")]), _vm._v(" ")])]
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "pos-rel p-t-20"
  }, [_c('btnGroup', {
    attrs: {
      "selectedData": _vm.multipleSelection,
      "type": 'bpm/flows'
    },
    on: {
      "toggleCallback": _vm.handleBtnResult
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "block pages"
  }, [_c('el-pagination', {
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.limit,
      "current-page": _vm.currentPage,
      "total": _vm.dataCount
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })])]), _vm._v(" "), _c('el-dialog', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dialogVisible),
      expression: "dialogVisible"
    }],
    attrs: {
      "title": "流程发起提示",
      "size": "tiny"
    },
    domProps: {
      "value": (_vm.dialogVisible)
    },
    on: {
      "input": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('span', [_vm._v("是否发起一个流程？")]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.createFlow
    }
  }, [_vm._v("确 定")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e5790fe6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Flow/abstract/list.vue
// module id = 2000
// module chunks = 2